import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { PREDEFINED_PRICING_TIERS_FEATURE_KEY } from './keys';
import { predefinedPricingTiersReducer } from './reducers/predefined-pricing-tiers.reducer';
import { PredefinedPricingTiersEffects } from './effects/predefined-pricing-tiers.effects';

export function providePredefinedPricingTiersStore(): EnvironmentProviders[] {
    return [provideState(PREDEFINED_PRICING_TIERS_FEATURE_KEY, predefinedPricingTiersReducer), provideEffects(PredefinedPricingTiersEffects)];
}
